const TOKEN_KEY = 'admin-panel.jwt';
const RETURN_TO_KEY = 'admin-panel.returnTo';

export const authStorage = {
  getToken(): string | null {
    try {
      return window.localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  setToken(token: string) {
    try {
      window.localStorage.setItem(TOKEN_KEY, token);
    } catch {
      /* storage disabled */
    }
  },
  clearToken() {
    try {
      window.localStorage.removeItem(TOKEN_KEY);
    } catch {
      /* storage disabled */
    }
  },
  getReturnTo(): string | null {
    try {
      return window.sessionStorage.getItem(RETURN_TO_KEY);
    } catch {
      return null;
    }
  },
  setReturnTo(path: string) {
    try {
      window.sessionStorage.setItem(RETURN_TO_KEY, path);
    } catch {
      /* storage disabled */
    }
  },
  clearReturnTo() {
    try {
      window.sessionStorage.removeItem(RETURN_TO_KEY);
    } catch {
      /* storage disabled */
    }
  },
};

export interface DecodedAdminJwt {
  email: string;
  name?: string;
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

export function decodeJwt(token: string): DecodedAdminJwt | null {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = atob(padded);
    const decoded = JSON.parse(json) as DecodedAdminJwt;
    if (typeof decoded !== 'object' || decoded === null || typeof decoded.email !== 'string') return null;
    return decoded;
  } catch {
    return null;
  }
}

export function isTokenExpired(decoded: DecodedAdminJwt | null): boolean {
  if (!decoded?.exp) return false;
  return decoded.exp * 1000 < Date.now();
}
